import React, { useEffect, useState } from "react";
import { getDateFromTime, getShipment } from "../../store/utility";
import OrderRow from "../UI/OrderRow/OrderRow";

const CancelledOrders = (props) => {
  let order = props.order;
  const [products, setProducts] = useState([]);

  useEffect(async () => {
    let order = props.order;
    if (order) {
      let products = [];
      for (let i = 0; i < order.products.length; i++) {
        let product = order.products[i];
        let { Status } = await getShipment(product, order);
        if (["RETURNED", "RTO"].includes(Status)) {
          products.push(product);
        }
      }
      setProducts(products);
    }
  }, []);

  return (
    <div className="container">
      {products.map((product) => (
        <OrderRow product={product} order={order} />
      ))}
    </div>
  );
};

export default CancelledOrders;
